import { Box, Card, Divider, Drawer, IconButton, Menu, MenuItem, Table, TableBody, TableCell, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch } from 'react-redux';
import { getAllScreenById } from 'src/redux/actions/Screen';
import MonitorIcon from '@mui/icons-material/Monitor';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { api } from 'src/api/endpoints';
import toast from 'react-hot-toast';

const ScreensDrawer = ({open, onClose, attachScheduler, setdetachSchedulerDialog}) => {
    const {t} = useTranslation()
    const dispatch = useDispatch()

    const {allScreens, screensCount} = useSelector((state) => (
        {
            allScreens: state.Screen.screens,
            screensCount: state.Screen.screensCount
        }
    ))

    const [searchScreensPhrase, setSearchScreensPhrase] = useState('')
    const [menuAnchor, setMenuAnchor] = useState(null)
    const menuOpen = Boolean(menuAnchor);
    const [activeScreenId, setActiveScreenId] = useState(null)

    const handleOpenMenu = (event, screenId) => {
        setMenuAnchor(event.currentTarget)
        setActiveScreenId(screenId)
    }

    const handleCloseMenu = (option) => {
        setMenuAnchor(null)
        if(option && activeScreenId){
            const screen = allScreens.find(sc => sc._id === activeScreenId)
            switch (option){
                case 'attachScheduler':
                    attachScheduler(screen)
                    break
                case 'detachScheduler': 
                    setdetachSchedulerDialog({open: true, screen})
                    break
            }
        }
    }

    const handleScreensSearch = () => {
        dispatch(getAllScreenById('123', '', 0, '', searchScreensPhrase, '', true))
    }

    // Auto-refresh screens when drawer opens
    useEffect(() => {
        if (open) {
            dispatch(getAllScreenById('123', '', 0, '', searchScreensPhrase, '', true))
        }
    }, [open, dispatch])

    return (
        <Drawer open={open} onClose={onClose}>
            <Box sx={{
                minWidth: "300px",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                p: 3
            }}>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 2
                }}>
                    <TextField
                        variant="outlined"
                        label={t("views.scheduler.searchScreens")}
                        value={searchScreensPhrase}
                        onInput={(e) => setSearchScreensPhrase(e.target.value)}
                        sx={{
                            width:"100%"
                        }}
                    />
                    <IconButton onClick={handleScreensSearch}>
                        <SearchIcon color="primary"/>
                    </IconButton>
                </Box>
                <Typography variant="subtitle1" textAlign="center">Available Screens</Typography>
                <Divider />
                <Table size="small">
                    <TableBody>
                        {screensCount > 0 ? (
                            allScreens.map((screen, i) => (
                                <TableRow key={`${screen._id}-${i}`} hover>
                                    <TableCell width={48}>
                                        <Tooltip title={screen?.isOnline ? (screen?.isInOfflineMode ? t("components.tableBodies.offlineMode") : t("components.tableBodies.online")) : t("components.tableBodies.offline")}>
                                            <MonitorIcon color={screen?.isOnline ? (screen?.isInOfflineMode ? 'warning' : 'success') : 'error'}/>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip title={screen?.deviceName?.length > 20 && screen?.deviceName}>
                                            <Typography>{screen?.deviceName?.length > 20 ? `${screen?.deviceName?.slice(0, 20)}...` : screen?.deviceName}</Typography>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell width={48}>
                                        <CalendarMonthIcon sx={{
                                            color: screen?.scheduler?.color ? screen?.scheduler?.color : ''
                                        }}/>
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip title={screen?.scheduler?.name?.length > 17 && screen?.scheduler?.name}>
                                            <Typography color={screen?.scheduler?.name ? '' : "text.secondary"}>{screen?.scheduler?.name ? (screen?.scheduler?.name?.length > 17 ? `${screen?.scheduler?.name?.slice(0, 17)}...` : screen?.scheduler?.name) : "------------"}</Typography>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell align="right" width={48}>
                                        <IconButton onClick={(e) => handleOpenMenu(e, screen._id)} id={`screenMenuOpenButton-${screen._id}`}>
                                            <MoreVertIcon/>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={5}>
                                    <Typography textAlign="center">{t("views.scheduler.noScreens")}</Typography>
                                    <Typography textAlign="center" variant="subtitle1">{t("views.scheduler.tryToSearch")}</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <Menu
                    anchorEl={menuAnchor}
                    open={menuOpen}
                    onClose={() => handleCloseMenu(null)}
                    slotProps={{
                        list: {
                            'aria-labelledby': activeScreenId ? `screenMenuOpenButton-${activeScreenId}` : undefined,
                        },
                    }}
                    id='screenMenu'
                >
                    {(() => {
                        const screen = allScreens.find(sc => sc._id === activeScreenId)
                        if(!screen) return null
                        return [
                            <MenuItem key="attach" onClick={() => handleCloseMenu('attachScheduler')}>
                                {screen?.scheduler?.name ? t("views.scheduler.switchScheduler") : t("views.scheduler.attachScheduler")}
                            </MenuItem>,
                            screen?.scheduler?.name && (
                                <MenuItem key="detach" onClick={() => handleCloseMenu('detachScheduler')}>
                                    {t("views.scheduler.detachScheduler")}
                                </MenuItem>
                            )
                        ].filter(Boolean)
                    })()}
                </Menu>
            </Box>
        </Drawer>
    )
}

export default ScreensDrawer
